import functions from '../../functions';

if (window.wp && window.wp.ajax)
{
    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, InnerBlocks } = window.wp.editor;
    const { PanelBody, TextControl, TextareaControl, ToggleControl } = window.wp.components;
    const { createElement } = window.wp.element;

    registerBlockType('custom-gutenberg/note-item', {
        title: 'Note Item',
        description: 'Icon + Title',
        icon: 'info',
        category: 'custom-cards',

        attributes: {
            icon: { type: 'string', default: '' },
            title: { type: 'string', default: '' },
            classes: { type: 'string', default: '' },
        },

        edit: function (props)
        {
            const { attributes, setAttributes } = props;
            const { icon, title, classes } = attributes;

            let className = props.className;
            className = functions.getClassNames(className);

            // Update classes automatically if needed
            if (classes !== className) setAttributes({ classes: className });

            // Add vertical class dynamically
            const wrapperClasses = classes + ' d-flex align-items-start';

            return [
                /* ======================
                   SIDEBAR SETTINGS
                ====================== */
                createElement(
                    InspectorControls,
                    {},
                    createElement(
                        PanelBody,
                        { title: 'Feature Note Settings', initialOpen: true },

                        /* Icon */
                        createElement(TextControl, {
                            label: 'Icon (text, emoji, SVG, class)',
                            value: icon,
                            onChange: (val) => setAttributes({ icon: val })
                        }),

                        /* Title */
                        createElement(TextControl, {
                            label: 'Title',
                            value: title,
                            onChange: (val) => setAttributes({ title: val })
                        }),

                        
                    )
                ),

                /* ======================
                   EDITOR PREVIEW
                ====================== */
                createElement(
                    'div',
                    { className: wrapperClasses },

                    // ICON
                    createElement(
                        'div',
                        { className: 'icon', style: { width: '56px', height: '56px' } },
                        createElement('i', { className: icon })
                    ),

                    // TEXTS
                    createElement(
                        'div',
                        { className: 'flex-grow-1' },
                        createElement(InnerBlocks),
                    )
                )
            ];
        },

        /* ======================
           FRONTEND SAVE
        ====================== */
        save: function (props)
        {
            const { icon, title, subtitle, anchor, classes, vertical } = props.attributes;

            const wrapperClasses = classes;

            return createElement(
                'div',
                { className: wrapperClasses },

                // ICON
                createElement(
                    'div',
                    { className: 'icon' },
                    createElement('i', { className: icon })
                ),

                // TEXT BLOCK
                createElement(
                    'div',
                    { className: 'flex-grow-1 title' },
                    createElement(InnerBlocks.Content),
                )
            );
        }
    });
}
